export const ERROR_CODE = {
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS'
};

export const WARRANTY_ACTIVATION_STATUS = {
  INVALID_SERIAL_NUMBER: 'INVALID_SERIAL_NUMBER',
  ACTIVATED: 'ACTIVATED',
  NO_PENDING_WARRANTY_ACTIVATION: 'NO_PENDING_WARRANTY_ACTIVATION'
};

export const WARRANTY_ACTIVATION_EVENTS = {
  SERIAL_NUMBER: 'serialNumber',
  INVALID_SERIAL_NUMBER: 'Invalid serial number',
  DEVICE_ALREADY_ACTIVATED: 'Device already activated',
  HOME: 'Home'
};

export const WARRANTY_ACTIVATION_ERRORS = {
  SERIAL_NUMBER: 'serialNumber'
};

export const PASSWORD_RESET = {
  RESET_PASSWORD: 'Reset password',
  INVALID_TOKEN: 'Invalid token'
};

export const ORDERID_REQUIRED_COUNTRIES = ['sg', 'my', 'hk', 'vn', 'tw'];

export const OPTIONAL_WARRANTY_FIELDS = ['lastName', 'orderId'];

export const ERROR_REPORT_SCOPE = {
  AUTH_TOKEN_VERIFY: 'AUTH_TOKEN_VERIFY',
  TREATMENT_FETCH: 'TREATMENT_FETCH'
};
